import React from "react";
import { NormalizedNutritionV2 } from "../type";
import TileGrid from "./TileGrid";
import { ReadOnlyFieldConfig } from "../ReadOnlyField";

type Props = {
  data: NormalizedNutritionV2;
  openPopperId: string | null;
  setOpenPopperId: React.Dispatch<React.SetStateAction<string | null>>;
};

const EatingPatternTab = ({ data, openPopperId, setOpenPopperId }: Props) => {
  const { eatingPattern } = data;

  // Row-major, and exactly 9 tiles → a clean 3×3 as designed. "Workout-specific
  // meals" used to sit here, read across from `workoutFuels`; it now renders in
  // the Workout Fuels section, which is where it lives in the data model, so
  // this section no longer reaches outside `eatingPattern`.
  const tiles: ReadOnlyFieldConfig[] = [
    {
      label: "Preferred diet",
      value: eatingPattern.dietType,
      fieldKey: "preferred-diet",
    },
    {
      label: "Meals eaten daily",
      value:
        eatingPattern.dailyMeals.items.length > 0
          ? eatingPattern.dailyMeals.items.join(", ")
          : "—",
      fieldKey: "meals-eaten-daily",
      items: eatingPattern.dailyMeals.items.map((name) => ({ name })),
    },
    {
      label: "Intermittent fasting",
      value: eatingPattern.intermittentFasting,
      fieldKey: "intermittent-fasting",
    },
    {
      label: "Eats from",
      value: eatingPattern.eatsFrom,
      fieldKey: "eats-from",
    },
    {
      label: "Eats until",
      value: eatingPattern.eatsUntil,
      fieldKey: "eats-until",
    },
    {
      label: "Largest meal",
      value: eatingPattern.largestMeal,
      fieldKey: "largest-meal",
    },
    { label: "Bed time", value: eatingPattern.bedTime, fieldKey: "bed-time" },
    { label: "Wake up", value: eatingPattern.wakeUpTime, fieldKey: "wake-up" },
    { label: "Lunch", value: eatingPattern.lunchTime, fieldKey: "lunch" },
  ];

  return (
    <TileGrid
      tiles={tiles}
      openPopperId={openPopperId}
      setOpenPopperId={setOpenPopperId}
    />
  );
};

export default EatingPatternTab;
